<template>
  <div class="app-container">
    <div class="activity-list-filter">
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="区域" v-model="filter.regionName" size="medium" :disabled="filterDisable.regionName" clearable>
               <el-option
                v-for="item in regionOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
         <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="市场" v-model="filter.marketId" size="medium" :disabled="filterDisable.marketId" clearable>
               <el-option
                v-for="item in marketOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="总经理" v-model="filter.gmEid" size="medium" :disabled="filterDisable.gmEid" clearable>
               <el-option
                v-for="item in GMOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运总监" v-model="filter.doEid" :disabled="filterDisable.doEid" size="medium" clearable>
              <el-option
                v-for="item in DOOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
         <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运经理" v-model="filter.omEid" :disabled="filterDisable.omEid" size="medium" clearable>
              <el-option
                v-for="item in OMOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运顾问" v-model="filter.ocEid" :disabled="filterDisable.ocEid" size="medium" clearable>
              <el-option
                v-for="item in OCOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="餐厅国际编号" v-model="filter.storeCode" :disabled="filterDisable.storeCode" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="餐厅名称" v-model="filter.storeId" :disabled="filterDisable.storeId" size="medium" clearable>
              <el-option
                v-for="item in storeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="比拼岗位" v-model="filter.positionId" size="medium" clearable>
              <el-option
                v-for="item in positionOptions"
                :key="item.id"
                :label="item.positionName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="员工编号" v-model="filter.unionId" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="员工姓名" v-model="filter.nickName" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="身份" v-model="filter.identity" size="medium" clearable>
              <el-option
                v-for="item in identityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-input @keyup.enter.native="loadData(true)" class="activity-list-filter-value" placeholder="裁判" v-model="filter.judgmentName" size="medium" />
          </div>
        </el-col>
        <el-col :span="20">
          <div>
            <el-button class="activity-list-filter-search" size="medium" @click="loadData(true)">立即筛选</el-button>
            <el-button class="activity-list-filter-reset" size="medium" @click="clearFilter([])">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud
        :page="pageItem"
        :data="displayData"
        @current-change="pageItem.currentPage=$event;loadData()"
        @size-change="pageItem.pageSize=$event;loadData(true)"
        :option="restaurantListOption"
        :table-loading="loading">
        <template slot="menuLeft">
          <el-button class="filter-item"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>

import { restaurantListOption } from '@/const/crud/activity/restaurant';
import { identityOptions } from '@/const/crud/activity/activity';
import { fetchStoreOptions, fetchRestaurantMatchesList, fetchPositionOptions, fetchActivityFilterOptions, fetchActivityFilter, exportPositionMatchRecordData } from '@/api/activity/activity';
import { exporting } from '@/util/exportUtil'

export default {
  data() {
    return {
      data: [],
      pageItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      loading: false,
      identityOptions,
      restaurantListOption,
      filter: {
        regionName: '',
        marketId: '',
        gmEid: '',
        doEid: '',
        omEid: '',
        ocEid: '',
        storeCode: '',
        storeId: '',
        positionId: '',
        unionId: '',
        nickName: '',
        identity: '',
        judgmentName: '',
      },
      filterOption: {},
      filterDisable: {},
      notClearOptions: false,
      marketOptions: [],
      regionOptions: [],
      GMOptions: [],
      DOOptions: [],
      OMOptions: [],
      OCOptions: [],
      positionOptions: [],
      storeOptions: [],
      exportName: '导出',
      exportLoading: false,
    }
  },
  async created() {
    await this.loadFilterOptions();
    await this.loadPositionOptions();
    await this.loadData(true);
  },
  computed: {
    displayData() {
      const data = JSON.parse(JSON.stringify(this.data));
      data.forEach(item => {
        this.restaurantListOption.column.forEach(col => {
          item[col.prop] = !!item[col.prop] || item[col.prop] === 0 ? item[col.prop] : '--';
        });
        item['unionId'] = [item['firstMemberUnionId'], item['secondMemberUnionId']].filter(Boolean).join('&') || '--';
        item['nickname'] = [item['firstMemberNickname'], item['secondMemberNickname']].filter(Boolean).join('&') || '--';
        item['identity'] = [item['firstMemberIdentity'], item['secondMemberIdentity']].filter(Boolean).join('&') || '--';
        item['totalScore'] = item['totalScore'] === '--' ? '--' : `${item['totalScore']}分`;
        item['positionScore'] = item['positionScore'] === '--' ? '--' : `${item['positionScore']}分`;
        item['serviceScore'] = item['serviceScore'] === '--' ? '--' : `${item['serviceScore']}分`;
        item['serviceSpeed'] = item['serviceSpeed'] === '--' ? '--' : `${item['serviceSpeed']}秒`;
        item['signUpTime'] = item['signUpTime'].split('.')[0];
      });
      return data;
    }
  },
  watch: {
    'filter.regionName': {
      handler(val) {
        if (!this.notClearOptions) {
          const excludedClearOptions = ['regionName', 'storeCode',];
          this.clearOptions(excludedClearOptions);
        }
        this.marketOptions = this.filterOption.markets.filter(x => x.parentId === val);
      }
    },
    'filter.marketId': {
      handler(val) {
        if (!this.notClearOptions) {
          const excludedClearOptions = ['regionName', 'marketId', 'storeCode',];
          this.clearOptions(excludedClearOptions);
        }
        this.GMOptions = this.filterOption.gms.filter(x => x.parentId === val);
      }
    },
    'filter.gmEid': {
      handler(val, oldVal) {
        if (val) {
          this.DOOptions = this.filterOption.dos.filter(x => x.parentId === val);
        } else {
          this.DOOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.doEid = '';
        }
      }
    },
    'filter.doEid': {
      handler(val, oldVal) {
        if (val) {
          this.OMOptions = this.filterOption.oms.filter(x => x.parentId === val);
        } else {
          this.OMOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.omEid = '';
        }
      }
    },
    'filter.omEid': {
      handler(val, oldVal) {
        if (val) {
          this.OCOptions = this.filterOption.ocs.filter(x => x.parentId === val);;
        } else {
          this.OCOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.ocEid = '';
        }
      }
    },
    'filter.ocEid': {
      handler(val, oldVal) {
        if (val) {
          this.loadStoreList();
        } else {
          this.storeOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.storeId = '';
        }
      }
    },
    'filter.storeCode': {
      handler(val, oldVal) {
        if (this.filterDisable.storeId || (!this.filter.ocEid && !this.filterDisable.storeId)) {
          return;
        }
        this.loadStoreList();
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.storeId = '';
        }
      }
    },
  },
  methods: {
    async loadData(init) {
      this.loading = true;
      this.pageItem.currentPage = init ? 1 : this.pageItem.currentPage;
      const page = {
        current: this.pageItem.currentPage,
        size: this.pageItem.pageSize,
      };
      const filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), page);
      await fetchRestaurantMatchesList(filter).then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.data = response.data.data.records;
          this.pageItem.total = response.data.data.total;
          this.loading = false;
        }
      });
    },
    async loadFilterOptions() {
      await fetchActivityFilterOptions().then(response => {
        if (response.data && response.data.code === 0) {
          this.filterOption = response.data.data;
          this.regionOptions = this.filterOption.regions;
        }
      });
      await fetchActivityFilter().then(res => {
        const result = res.data.data;
        if(!result) {
          return;
        }
        if (result.roleType === 'OC_OM_DO') {
          this.notClearOptions = true;
          this.generateFilter(result.eid);
        } else if (result.roleType === 'STORE_MANAGEMENT') {
          this.notClearOptions = true;

          this.filterDisable.regionName = true;
          this.filterDisable.marketId = true;
          this.filterDisable.gmEid = true;
          this.filterDisable.doEid = true;
          this.filterDisable.omEid = true;
          this.filterDisable.ocEid = true;
          this.filterDisable.storeCode = true;
          this.filterDisable.storeId = true;

          this.filter.regionName = result.regionName || '';
          this.filter.marketId = result.marketId || '';
          this.filter.gmEid = result.gmEid || '';
          this.filter.doEid = result.doEid || '';
          this.filter.omEid = result.omEid || '';
          this.filter.ocEid = result.ocEid || '';
          this.filter.storeCode = result.usCode || '';
          this.filter.storeId = result.storeId || '';

        }
      });
    },
    generateFilter(eid) {
      let eidKey = eid;
      let filterOcs = this.filterOption.ocs.filter(item => item.eid === eidKey);
      if (filterOcs && filterOcs.length > 0) {
        this.filter.omEid = filterOcs[0].parentId || '';
        this.filterDisable.omEid = true;
        eidKey = this.filter.omEid;
      }

      let filterOms = this.filterOption.oms.filter(item => item.eid === eidKey);
      if (filterOms && filterOms.length > 0) {
        this.filter.doEid = filterOms[0].parentId;
        this.filterDisable.doEid = true;
        eidKey = this.filter.doEid;
      }

      let filterDos = this.filterOption.dos.filter(item => item.eid === eidKey);
      if (filterDos && filterDos.length > 0) {
        this.filter.gmEid = filterDos[0].parentId;
        this.filterDisable.gmEid = true;
        eidKey = this.filter.gmEid;
      }

      let filterGms = this.filterOption.gms.filter(item => item.eid === eidKey);
      if (filterGms && filterGms.length > 0) {
        this.filter.marketId = filterGms[0].parentId;
        this.filterDisable.marketId = true;
        eidKey = this.filter.marketId;
      }

      let filterMarkets = this.filterOption.markets.filter(item => item.eid === eidKey);
      if (filterMarkets && filterMarkets.length > 0) {
        this.filter.regionName = filterMarkets[0].parentId;
        this.filterDisable.regionName = true;
      }
    },
    async loadPositionOptions() {
      await fetchPositionOptions().then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.positionOptions = response.data.data;
        }
      })
    },
    loadStoreList() {
      const params = {
        marketId: this.filter.marketId,
        regionName: this.filter.regionName,
        doEid: this.filter.doEid,
        gmEid: this.filter.gmEid,
        ocEid: this.filter.ocEid,
        omEid: this.filter.omEid,
        storeCode: this.filter.storeCode,
      }
      fetchStoreOptions(params).then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.storeOptions = response.data.data;
        }
      })
    },
    clearOptions(excluded) {
      this.GMOptions = [];
      this.DOOptions = [];
      this.OMOptions = [];
      this.OCOptions = [];
      this.storeOptions = [];
      this.clearFilter(excluded);
    },
    clearFilter(excludedColumn) {
      let excluded = [];
      excluded = excluded.concat(excludedColumn || []);
      excluded = excluded.concat(Object.keys(this.filterDisable));
      Object.keys(this.filter).forEach(key => {
        if (!excluded || excluded.indexOf(key) < 0) {
          this.filter[key] = '';
        }
      });
      if (!excludedColumn || excludedColumn.length < 1) {
        this.loadData(true);
      }
    },
    handleExport() {
      exportPositionMatchRecordData(this.filter).then(response => {
        if (response.status === 200 && response.data && response.data.data) {
          this.exportLoading = true
          this.exportName = "导出中..."
          exporting(response.data.data, this.exportCallback)
        } else {
          this.$message({
            message: '信息导出失败',
            type: 'warning',
            showClose: true,
          });
        }
      });
    },
    exportCallback(result) {
      this.exportLoading = false
      this.exportName = "导出"
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.activity-list-filter {
  margin: 0 10px;
  &-value {
    width: 96% !important;
  }
  &-reset {
    float: right;
    margin-right: 8px;
  }
  &-search {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
</style>